import { useSelector } from 'react-redux'

import { Colors } from '~/styles'
import { ConvertLocalTimeGet, GetDurationFractionHours } from '~/utils'

const useHooks = () => {
  const { Location } = useSelector((state) => state.usersProfileReducer)

  const formatDate = (date, format = 'DD MMMM YYYY HH:mm') => {
    return ConvertLocalTimeGet(Location.LocationDescription, date, format)
  }

  const formatDuration = (startDate, finishDate) => {
    if (!startDate) {
      return ''
    }

    const duration = GetDurationFractionHours(startDate, (finishDate || new Date()), 0)
    return `${parseFloat(duration / 60).toFixed(1)} hrs`
  }

  const mapActivityColorStatus = (tasks) => {
    const filteredTasks = tasks.filter(task => task.level_value !== 'Not Applicable')

    if (filteredTasks.some(task => task.is_red)) {
      return Colors.newRed
    }

    if (filteredTasks.some(task => task.is_orange)) {
      return Colors.newOrange
    }

    if (filteredTasks.every(task => task.is_green)) {
      return Colors.newGreen
    }

    return Colors.grey
  }

  const mapTaskColorStatus = (task) => {
    if (task.is_red) {
      return Colors.newRed
    }
    if (task.is_orange) {
      return Colors.newOrange
    }
    if (task.is_green) {
      return Colors.newGreen
    }
    return Colors.grey
  }

  return {
    methods: {
      formatDate,
      formatDuration,
      mapTaskColorStatus,
      mapActivityColorStatus,
    }
  }
}

export default useHooks